import { isEmpty } from 'ramda';
import * as types from '../constants/ActionTypes';
import { getEditorialHomeworkSubject } from '../lib/HomeworkUtils';

export const initialState = {
    contentTaxonomy: [],
    errorMsg: '',
    errorType: '',
    favouriteOnly: false,
    filters: {
        books: [],
        authors: [],
        subjects: []
    },
    homeworkCount: 0,
    homeworkList: [],
    isSuggestionSelected: false,
    loaded: true,
    loadedHomeworkContentTaxonomy: true,
    searchIdList: [],
    searchPage: 1,
    searchTerm: '',
    showFavouriteToggle: false
};

export default function EditorialHomework(state = initialState, action = {}) {
    switch (action.type) {
        case types.SEARCH_EDITORIAL_HOMEWORK:
            return {
                ...state,
                filters: action.payload.filters,
                homeworkCount: 0,
                homeworkList: [],
                isSuggestionSelected: action.payload.isSuggestionSelected,
                loaded: false,
                searchIdList: action.payload.searchIdsList,
                searchPage: 1,
                searchTerm: action.payload.searchTerm,
                favouriteOnly: action.payload.favouriteOnly
            };
        case types.SEARCH_EDITORIAL_HOMEWORK_SUCCESS:
            if (action.payload.result.length < 1) {
                return {
                    ...state,
                    errorMsg: 'La ricerca non ha prodotto alcun risultato.',
                    homeworkCount: 0,
                    homeworkList: [],
                    loaded: true,
                    showFavouriteToggle: !state.favouriteOnly ? false : true
                };
            } else {
                return {
                    ...state,
                    errorMsg: '',
                    homeworkCount: action.payload.totalCount,
                    homeworkList: action.payload.result.map(editorialHomework => ({
                        ...editorialHomework,
                        bookTitle: editorialHomework.bookTitle,
                        subject: getEditorialHomeworkSubject(editorialHomework.subjects)
                    })),
                    loaded: true,
                    errorType: '',
                    showFavouriteToggle: true
                };
            }
        case types.SEARCH_EDITORIAL_HOMEWORK_FAILURE:
            return {
                ...state,
                loaded: true,
                errorMsg:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi.',
                errorType: 'CAT_FAILURE',
                showFavouriteToggle: false
            };
        case types.SEARCH_MORE_EDITORIAL_HOMEWORK: {
            return {
                ...state,
                loaded: false,
                errorMsg: '',
                errorType: '',
                favouriteOnly: action.payload.favouriteOnly
            };
        }
        case types.SEARCH_MORE_EDITORIAL_HOMEWORK_SUCCESS: {
            return {
                ...state,
                homeworkList: state.homeworkList.concat(
                    action.payload.result.map(editorialHomework => ({
                        ...editorialHomework,
                        bookTitle: editorialHomework.bookTitle,
                        subject: getEditorialHomeworkSubject(editorialHomework.subjects)
                    }))
                ),
                loaded: true,
                errorMsg: '',
                errorType: '',
                searchPage: action.payload.searchPage
            };
        }
        case types.SEARCH_MORE_EDITORIAL_HOMEWORK_FAILURE: {
            return {
                ...state,
                loaded: true,
                errorMsg:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi.',
                errorType: 'CAT_FAILURE',
                showFavouriteToggle: false
            };
        }
        case types.HOMEWORKS_EDITORIAL_FILTERS_CHANGE:
            const searchIdList = action.payload.searchIdList ? action.payload.searchIdList : state.searchIdList;
            const searchTerm = action.payload.searchTerm ? action.payload.searchTerm : action.payload.filters.subjects ? '' : state.searchTerm;
            return {
                ...state,
                searchIdList,
                searchTerm,
                filters: {
                    ...state.filters,
                    ...action.payload.filters
                }
            };
        case types.GET_HOMEWORK_CONTENT_TAXONOMY: {
            return {
                ...state,
                loadedHomeworkContentTaxonomy: false,
                errorMsg: '',
                errorType: ''
            };
        }
        case types.GET_HOMEWORK_CONTENT_TAXONOMY_SUCCESS: {
            if (action.result && !isEmpty(action.result)) {
                return {
                    ...state,
                    contentTaxonomy: action.result,
                    loadedHomeworkContentTaxonomy: true,
                    errorMsg: '',
                    errorType: ''
                };
            }
            return {
                ...state,
                loadedHomeworkContentTaxonomy: true,
                errorMsg: 'La ricerca non ha prodotto alcun risultato.',
                errorType: ''
            };
        }
        case types.GET_HOMEWORK_CONTENT_TAXONOMY_FAILURE: {
            return {
                ...state,
                loadedHomeworkContentTaxonomy: true,
                errorMsg:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi.',
                errorType: 'ZNS_FAILURE'
            };
        }
        default:
            return state;
    }
}
